module.exports = __webpack_public_path__ + "media/images/nextlink_logo-17892bcef75cf5e7f862e782001418e8.png";